"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isResponseJson = isResponseJson;
function isResponseJson(headers) {
  return headers && (headers.get('content-type') || '').includes('application/json');
}
//# sourceMappingURL=response.js.map